module.exports = __webpack_public_path__ + "static/Epc-cb44270e658562ed70a48754a22f3f1b.png";